import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { JointBillContext } from "@features/JointBillList/utils";
import { Checkbox } from "@components/inputs/Checkbox/Checkbox";
import { SelectionState } from "@services/overview/types";
import { isNullOrUndefined } from "@utils/common";
import { formatPrice } from "@utils/units";

interface IJointBillFooterTotalCellProps {
  amount?: number;
  jointBillSelectionState?: SelectionState;
  onJointBillCheckboxClick?: () => void;
  isJointBillCheckboxDisabled?: boolean;
}

export const JointBillFooterTotalCell: React.FC<
  IJointBillFooterTotalCellProps
> = ({
  amount,
  jointBillSelectionState,
  onJointBillCheckboxClick,
  isJointBillCheckboxDisabled,
}) => {
  const { t } = useTranslation();
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex items-center gap-4">
      {!isNullOrUndefined(amount) && (
        <span className="whitespace-nowrap text-sm font-semibold md:text-lg">{`${t(
          "bill.toPay",
        )}: ${formatPrice(amount)}`}</span>
      )}
      {!isSummaryMode && (
        <Checkbox
          className="block md:hidden"
          checked={jointBillSelectionState === SelectionState.SELECTED}
          onChange={onJointBillCheckboxClick}
          disabled={isJointBillCheckboxDisabled}
          readOnly={true}
        />
      )}
    </div>
  );
};
